/* Busca por nome nas listas do painel.

   Um lugar só, porque a regra tem duas armadilhas que cada tela resolveria de
   um jeito diferente:

   1. ACENTO. Os nomes vêm do cadastro das redes e trazem acentuação de verdade
      ("FORMANDO CIDADÃOS", "E. M. Antônio Pereira"). Quem digita numa busca
      raramente acentua, e um `includes()` cru não encontra "antonio" em
      "Antônio". A normalização NFD tira os diacríticos antes de comparar, dos
      dois lados.

   2. MAIÚSCULA. Os nomes do mart chegam em caixa inteiramente alta em algumas
      redes e em caixa mista em outras — comparar sem baixar a caixa faria a
      mesma busca funcionar num cliente e falhar no outro.

   A busca é por SUBSTRING, não por prefixo: quem procura "municipal" quer achar
   "E. M. Municipal do Bairro". E é por TERMOS, não pela frase inteira — "antonio
   pereira" acha "ANTÔNIO A. PEREIRA", que uma comparação de frase perderia por
   causa do "A." no meio.

   ⚠️ Isto filtra o que a tela JÁ TEM em mãos. Em lista paginada (o ranking de
   escolas vem com per_page) filtrar aqui esconderia da busca tudo o que está
   fora da página corrente — nesses casos o filtro tem de ir ao servidor, que é
   o que faz o parâmetro `nome` da rota /escolas. */

/** Sem acento, sem caixa, sem espaço sobrando. */
export const normalizar = texto =>
  String(texto ?? "")
    .normalize("NFD")
    // Faixa dos diacríticos combinantes — escapada, e não colada literalmente,
    // para o arquivo não depender de encoding na hora de ler o padrão.
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

/**
 * Filtra a lista pelos campos informados.
 *
 * @param {Array} lista   linhas a filtrar (null/undefined viram [])
 * @param {string} termo  o que o usuário digitou
 * @param {Array<string>} campos  chaves de cada linha que entram na busca
 * @returns {Array} as linhas que casam — a própria lista quando o termo é vazio
 */
export const filtrarPorNome = (lista, termo, campos) => {
  const linhas = Array.isArray(lista) ? lista : [];
  const alvo = normalizar(termo);

  if (!alvo) return linhas;

  // Cada palavra digitada tem de aparecer em algum lugar do texto da linha.
  const termos = alvo.split(/\s+/).filter(Boolean);

  return linhas.filter(linha => {
    const texto = normalizar(campos.map(campo => linha?.[campo]).join(" "));
    return termos.every(t => texto.includes(t));
  });
};
